import React, { useContext } from "react";
import { ThemeContext } from "../../../../../context/ThemeContext";

const PendingOrdersTable = ({
  pendingOrders,
  formatMoney,
  formatDate,
  openDepositModal,
  selectedOrders,
  toggleOrder,
  totalSelectedAmount,
}) => {
  const { theme } = useContext(ThemeContext); // ← Theme Context

  const thStyle = {
    textAlign: "left",
    padding: 14,
    fontSize: 12,
    fontWeight: 700,
    color: theme.primary,
    borderBottom: `1px solid ${theme.border}`,
    background: theme.surfaceLighter,
    whiteSpace: "nowrap",
  };

  const tdStyle = {
    padding: 14,
    fontSize: 13,
    color: theme.textPrimary,
    borderBottom: `1px solid ${theme.border}`,
  };

  return (
    <div
      style={{
        background: theme.surface,
        border: `1px solid ${theme.border}`,
        borderRadius: 15,
        overflow: "hidden",
        marginTop: 20,
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: 18,
          fontSize: 18,
          fontWeight: "bold",
          color: theme.textPrimary,
          borderBottom: `1px solid ${theme.border}`,
          background: theme.surfaceLighter,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span>💰 Pending Cash Orders</span>
        <span
          style={{
            fontSize: 12,
            fontWeight: 500,
            color: theme.textMuted,
            background: `${theme.warning}1a`,
            padding: "4px 12px",
            borderRadius: 12,
          }}
        >
          Pending: {pendingOrders.length}
        </span>
      </div>

      {/* Empty State */}
      {pendingOrders.length === 0 ? (
        <div
          style={{
            padding: 60,
            textAlign: "center",
            color: theme.textMuted,
          }}
        >
          <div style={{ fontSize: 48, marginBottom: 12 }}>📦</div>
          <h3
            style={{
              color: theme.textPrimary,
              marginBottom: 8,
              fontSize: 16,
              fontWeight: 600,
            }}
          >
            No Pending Cash Orders
          </h3>
          <p style={{ color: theme.textMuted, fontSize: 13 }}>
            All cash orders have been collected
          </p>
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: 900,
            }}
          >
            <thead>
              <tr>
                <th style={{ ...thStyle, width: "50px" }}>Select</th>
                <th style={thStyle}>Order ID</th>
                <th style={thStyle}>Customer</th>
                <th style={thStyle}>Restaurant</th>
                <th style={thStyle}>Amount</th>
                <th style={thStyle}>Payment</th>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Action</th>
              </tr>
            </thead>

            <tbody>
              {pendingOrders.map((item) => {
                const isSelected = selectedOrders.some((o) => o.id === item.id);
                return (
                  <tr
                    key={item.id}
                    style={{
                      background: isSelected
                        ? `${theme.primary}12`
                        : "transparent",
                      transition: "background 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = isSelected
                        ? `${theme.primary}18`
                        : theme.surfaceHover || `${theme.primary}08`)
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = isSelected
                        ? `${theme.primary}12`
                        : "transparent")
                    }
                  >
                    {/* Checkbox */}
                    <td style={tdStyle}>
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => toggleOrder(item)}
                        style={{
                          width: 16,
                          height: 16,
                          cursor: "pointer",
                          accentColor: theme.primary,
                        }}
                      />
                    </td>

                    {/* Order ID */}
                    <td
                      style={{
                        ...tdStyle,
                        fontWeight: 600,
                        fontFamily: "monospace",
                        color: theme.primary,
                        fontSize: 12,
                      }}
                    >
                      #{item.id}
                    </td>

                    {/* Customer */}
                    <td style={{ ...tdStyle, color: theme.textSecondary }}>
                      {item.receiver_name || "-"}
                    </td>

                    {/* Restaurant */}
                    <td style={{ ...tdStyle, color: theme.textSecondary }}>
                      {item.organisation_name || "-"}
                    </td>

                    {/* Amount */}
                    <td
                      style={{
                        ...tdStyle,
                        color: theme.success,
                        fontWeight: "bold",
                      }}
                    >
                      {formatMoney(item.final_amount)}
                    </td>

                    {/* Payment Mode */}
                    <td style={tdStyle}>
                      <span
                        style={{
                          padding: "4px 10px",
                          borderRadius: 12,
                          fontSize: 11,
                          fontWeight: 600,
                          background:
                            item.payment_received_mode === "CASH"
                              ? `${theme.warning}1a`
                              : `${theme.primary}1a`,
                          color:
                            item.payment_received_mode === "CASH"
                              ? theme.warning
                              : theme.primary,
                        }}
                      >
                        {item.payment_received_mode || "-"}
                      </span>
                    </td>

                    {/* Date */}
                    <td
                      style={{
                        ...tdStyle,
                        color: theme.textMuted,
                        fontSize: 12,
                      }}
                    >
                      {formatDate(item.created_at)}
                    </td>

                    {/* Action */}
                    <td style={tdStyle}>
                      <button
                        style={{
                          padding: "6px 12px",
                          border: "none",
                          borderRadius: 8,
                          cursor: "pointer",
                          background: theme.primary,
                          color: "#fff",
                          fontSize: 11,
                          fontWeight: 600,
                          marginRight: 8,
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => console.log(item)}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.opacity = "0.9")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.opacity = "1")
                        }
                      >
                        View
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Footer with Selection Summary */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: 20,
              borderTop: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            <div>
              <div
                style={{
                  fontWeight: "bold",
                  color: theme.textPrimary,
                  fontSize: 14,
                }}
              >
                Selected:{" "}
                <span style={{ color: theme.primary }}>
                  {selectedOrders.length}
                </span>{" "}
                Orders
              </div>
              <div
                style={{
                  fontSize: 13,
                  color: theme.textSecondary,
                  marginTop: 4,
                }}
              >
                Total:{" "}
                <span style={{ color: theme.success, fontWeight: 600 }}>
                  {formatMoney(totalSelectedAmount)}
                </span>
              </div>
            </div>

            <button
              disabled={selectedOrders.length === 0}
              onClick={() => openDepositModal(selectedOrders)}
              style={{
                background:
                  selectedOrders.length === 0
                    ? theme.textMuted
                    : theme.success,
                color: "#fff",
                border: "none",
                padding: "12px 24px",
                borderRadius: 8,
                cursor:
                  selectedOrders.length === 0 ? "not-allowed" : "pointer",
                fontSize: 13,
                fontWeight: 600,
                opacity: selectedOrders.length === 0 ? 0.6 : 1,
                transition: "all 0.2s ease",
                boxShadow:
                  selectedOrders.length > 0
                    ? `0 4px 12px ${theme.success}40`
                    : "none",
              }}
              onMouseEnter={(e) => {
                if (selectedOrders.length > 0) {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = `0 6px 16px ${theme.success}60`;
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  selectedOrders.length > 0
                    ? `0 4px 12px ${theme.success}40`
                    : "none";
              }}
            >
              💰 Collect Selected
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingOrdersTable;